import { ChevronLeft, ChevronRight } from 'lucide-react';
import { MONTH_NAMES } from '../../constants/expenses';
import { formatCurrency } from '../../utils/formatters';

const CategoriesView = ({ year, month, expenses, loading, onPrev, onNext }) => {
  const grouped = {};
  for (const e of expenses) {
    const cat = e.category ?? 'Uncategorized';
    grouped[cat] = (grouped[cat] ?? 0) + e.amount;
  }

  const rows = Object.entries(grouped).sort((a, b) => b[1] - a[1]);
  const total = rows.reduce((s, [, amt]) => s + amt, 0);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <button
          onClick={onPrev}
          className="p-1.5 text-gray-400 hover:text-gray-900 transition-colors rounded-lg hover:bg-gray-50"
          aria-label="Previous month"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <h2 className="text-gray-900 font-semibold text-lg tracking-tight">
          {MONTH_NAMES[month - 1]} {year}
        </h2>
        <button
          onClick={onNext}
          className="p-1.5 text-gray-400 hover:text-gray-900 transition-colors rounded-lg hover:bg-gray-50"
          aria-label="Next month"
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-card overflow-hidden">
        {loading ? (
          <div className="px-5 py-8 text-center text-sm text-gray-400">Loading…</div>
        ) : rows.length === 0 ? (
          <div className="px-5 py-8 text-center text-sm text-gray-400">No expenses this month</div>
        ) : (
          <div className="divide-y divide-gray-100">
            {rows.map(([cat, amt]) => (
              <div key={cat} className="flex items-center justify-between px-5 py-3.5">
                <span className="text-sm font-medium text-gray-900">{cat}</span>
                <span className="text-sm font-semibold text-gray-900 tabular-nums">-{formatCurrency(amt)}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-card px-5 py-3 flex items-center justify-between">
        <span className="text-[11px] font-semibold text-gray-400 uppercase tracking-wide">Total</span>
        <span className="text-sm font-semibold text-gray-900 tabular-nums">-{formatCurrency(total)}</span>
      </div>
    </div>
  );
};

export default CategoriesView;
